import { useIntl } from 'react-intl';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import {
	OffsetIconCollection,
	iconDataProps,
} from '@/patterns/offset-icon-collection/offset-icon-collection';
import { checkFeatureFlagGate } from '@/utils/feature-flags/check-feature-flag';
import { featureFlags } from '@/utils/feature-flags/feature-flag-manifest';

export const IntegrationsSection = () => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const intl = useIntl();

	const useGWP7617Gate = checkFeatureFlagGate(featureFlags.gwp7617JiraShortTermAiInfusionGate);
	// TODO: add width and height prop to iconData to use in Picture component
	const iconData: iconDataProps[] = [
		{
			url: 'https://dam-cdn.atl.orangelogic.com/AssetLink/n773sikm845802hme5xs1ne04uy2g837.webp',
			altText: intl.formatMessage({
				id: 'jira-product-tour.integrations-section.microsoft-alt-text',
				defaultMessage: 'Microsoft Teams icon',
			}),
			width: 60,
			height: 50,
		},
		{
			url: 'https://dam-cdn.atl.orangelogic.com/AssetLink/s2b5621s46n36ogarwic4734b30xge4b.webp',
			altText: intl.formatMessage({
				id: 'jira-product-tour.integrations-section.google-drive-alt-text',
				defaultMessage: 'Google Drive icon',
			}),
			width: 60,
			height: 50,
		},
		{
			url: 'https://dam-cdn.atl.orangelogic.com/AssetLink/wrb81j78p4733kc10bdjw8v637h1w438.webp',
			altText: intl.formatMessage({
				id: 'jira-product-tour.integrations-section.google-doc-alt-text',
				defaultMessage: 'Google Docs icon',
			}),
			width: 60,
			height: 50,
		},

		{
			url: 'https://dam-cdn.atl.orangelogic.com/AssetLink/1m0x1742g31t1446203avy1kpi468me1.webp',
			altText: intl.formatMessage({
				id: 'jira-product-tour.integrations-section.figma-alt-text',
				defaultMessage: 'Figma icon',
			}),
			width: 48,
			height: 60,
		},
		{
			url: 'https://dam-cdn.atl.orangelogic.com/AssetLink/s2035t28j8p045avd6kjvjpr68g0uyfb.webp',
			altText: intl.formatMessage({
				id: 'jira-product-tour.integrations-section.miro-alt-text',
				defaultMessage: 'Miro icon',
			}),
			width: 60,
			height: 50,
		},

		{
			url: 'https://dam-cdn.atl.orangelogic.com/AssetLink/ow67lf57t0be1t6ami55288g1dx2kp46.webp',
			altText: intl.formatMessage({
				id: 'jira-product-tour.integrations-section.slack-alt-text',
				defaultMessage: 'Slack icon',
			}),
			width: 60,
			height: 58,
		},
		{
			url: 'https://dam-cdn.atl.orangelogic.com/AssetLink/uje2jom52scmv5bs8o1ej15sp162l6h0.webp',
			altText: intl.formatMessage({
				id: 'jira-product-tour.integrations-section.zoom-alt-text',
				defaultMessage: 'Zoom icon',
			}),
			width: 60,
			height: 13,
		},
	];

	const handleClick = () => {
		createAnalyticsEvent({
			eventType: 'ui',
			action: 'clicked',
			attributes: {
				name: 'atlas-55799-integrations-button-clicked',
				section: 'integration-section',
			},
		}).fire();
	};

	const headingText = useGWP7617Gate
		? intl.formatMessage({
				id: 'jira-product-tour.integrations-section.heading-text-gwp-7617',
				defaultMessage: 'Meet teams where they work',
			})
		: intl.formatMessage({
				id: 'jira-product-tour.integrations-section.heading-text',
				defaultMessage: 'Meets teams where they work',
			});

	return (
		<OffsetIconCollection
			headingText={headingText}
			bodyText={intl.formatMessage({
				id: 'jira-product-tour.integrations-section.body-text',
				defaultMessage:
					'If your team uses it, we integrate with it. Easily add your favorite tools from the Atlassian Marketplace, keeping Jira as your central source of truth.',
			})}
			iconData={iconData}
			ctaText={intl.formatMessage({
				id: 'jira-product-tour.integrations-section.cta-text',
				defaultMessage: 'Go to Marketplace',
			})}
			ctaLink="https://marketplace.atlassian.com"
			ctaOnClickFunc={handleClick}
		/>
	);
};
IntegrationsSection.displayName = 'IntegrationsSection';
